import Chip from "@mui/material/Chip";
import { theme } from "../styles/theme";

export const LocationCategoryTag = ({
  variant,
  text,
  iconCategory = false,
  color,
}) => {
  const locationCategoryTagStyles = {
    lineHeight: "1",
    height: "auto",
    backgroundColor: color,
    "& span": {
      color: theme.palette.common.white,
      fontSize: ".875rem",
    },
    "&.MuiChip-root": {
      "&::before": {
        content: "''",
        display: iconCategory ? "" : "none",
        width: ".75rem",
        height: ".75rem",
        transform: "translateX(.5rem)",
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        maskSize: ".75rem",
      },
    },
  };

  return (
    <Chip
      sx={locationCategoryTagStyles}
      component="span"
      variant={variant}
      label={text}
    />
  );
};
